var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2894_200",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 71,
    height: 71
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2894_200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.1642,
    cy: 35.5244,
    r: 34,
    transform: "rotate(61.2319 35.1642 35.5244)",
    stroke: "#67970B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0166 41.3248L49.0163 41.3244C49.0154 41.3229 49.0145 41.3215 49.0137 41.3201L44.7718 34.4811M49.0166 41.3248L44.7718 34.4811M49.0166 41.3248C49.1068 41.4706 49.1023 41.5778 49.08 41.6399C49.0578 41.7017 48.9948 41.7842 48.8371 41.8269C48.8346 41.8275 48.8323 41.8282 48.8301 41.8288L41.418 43.8116C41.0625 43.9066 40.5743 43.7019 40.3732 43.3744L40.3732 43.3743C40.2833 43.228 40.2885 43.1216 40.3108 43.0602C40.3331 42.9987 40.3967 42.9162 40.5556 42.8737C40.5556 42.8737 40.5556 42.8737 40.5556 42.8737L45.5355 41.5415L46.8617 41.1867L45.5536 40.6417L21.9208 30.7952C21.7002 30.7032 21.5415 30.5583 21.4552 30.4186C21.3692 30.2792 21.3674 30.1718 21.3918 30.1038C21.4163 30.0357 21.4848 29.9577 21.6355 29.917C21.7867 29.8761 21.9947 29.884 22.2153 29.9759L45.8481 39.8225L47.1563 40.3675L46.3974 39.144L43.5477 34.5496C43.5477 34.5496 43.5477 34.5496 43.5477 34.5496M49.0166 41.3248L43.5477 34.5496M44.7718 34.4811C44.5684 34.1531 44.0795 33.9508 43.7258 34.0472C43.5679 34.0902 43.5052 34.1727 43.4833 34.2343C43.4613 34.2959 43.4567 34.403 43.5477 34.5496M44.7718 34.4811L43.5477 34.5496M49.0027 41.3009C49.0036 41.3025 49.0049 41.305 49.0067 41.308C49.0045 41.3043 49.0029 41.3014 49.002 41.2997L49.0027 41.3009Z",
    fill: "#67970B",
    stroke: "#67970B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.1b3c008259f336fd1a141a5d85820ae6.svg";
export { ForwardRef as ReactComponent };